/**
 * Ürün ekranlarına (stok listesi, ürün kartı) özel küçük çizgi ikonlar.
 * Renk `currentColor`; boyut `boy` (px). Kabuğun ikon bileşeninden bağımsızdır.
 */
type Ad =
  | 'geri' | 'yukari' | 'asagi' | 'sol' | 'sag' | 'ara' | 'sutun' | 'sirala' | 'goz' | 'arti' | 'carpi' | 'cop'
  | 'yildiz' | 'gorsel' | 'disa' | 'ice' | 'sayim' | 'fiyat' | 'bag' | 'kalin' | 'italik' | 'liste' | 'numara'
  | 'baglanti' | 'temizle' | 'acilir' | 'tut' | 'kutu' | 'onay' | 'uyari' | 'kalem';

const YOL: Record<Ad, string> = {
  geri: 'M12.5 4.5 7 10l5.5 5.5',
  sol: 'M12.5 4.5 7 10l5.5 5.5',
  sag: 'M7.5 4.5 13 10l-5.5 5.5',
  yukari: 'M4.5 12.5 10 7l5.5 5.5',
  asagi: 'M4.5 7.5 10 13l5.5-5.5',
  acilir: 'M5.5 8 10 12.5 14.5 8',
  ara: 'M9 15A6 6 0 1 0 9 3a6 6 0 0 0 0 12Zm4.5-1.5L17 17',
  sutun: 'M4 4h12v12H4zM8 4v12M12 4v12',
  sirala: 'M6 4v12m0 0-2.5-2.5M6 16l2.5-2.5M14 16V4m0 0-2.5 2.5M14 4l2.5 2.5',
  goz: 'M2 10s3-5.5 8-5.5S18 10 18 10s-3 5.5-8 5.5S2 10 2 10Zm8 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  arti: 'M10 4v12M4 10h12',
  carpi: 'M5 5l10 10M15 5 5 15',
  cop: 'M4 6h12M8 6V4h4v2m-6 0 .7 10h6.6L14 6M8.5 9v4.5M11.5 9v4.5',
  yildiz: 'm10 3 2.2 4.5 4.8.7-3.5 3.4.8 4.9-4.3-2.3-4.3 2.3.8-4.9L3 8.2l4.8-.7L10 3Z',
  gorsel: 'M3.5 4.5h13v11h-13zM3.5 13l3.5-3.5 3 3 2.5-2.5 4 4M13 8.2a.9.9 0 1 0 0-.01',
  disa: 'M10 13V3.5m0 0L6.5 7M10 3.5 13.5 7M4 12v4h12v-4',
  ice: 'M10 3.5V13m0 0-3.5-3.5M10 13l3.5-3.5M4 12v4h12v-4',
  sayim: 'M4 5.5h2M4 10h2M4 14.5h2M9 5.5h7M9 10h7M9 14.5h7',
  fiyat: 'M3.5 10.5V4h6.5l6.5 6.5-6.5 6.5-6.5-6.5ZM7 7.4a.6.6 0 1 0 0-.01',
  bag: 'M8.5 11.5a3 3 0 0 0 4.2 0l2.6-2.6a3 3 0 0 0-4.2-4.2l-1 1M11.5 8.5a3 3 0 0 0-4.2 0l-2.6 2.6a3 3 0 0 0 4.2 4.2l1-1',
  kalin: 'M6 4h5a3 3 0 0 1 0 6H6zm0 6h6a3 3 0 0 1 0 6H6z',
  italik: 'M9 4h6M5 16h6M12 4 8 16',
  liste: 'M8 5.5h8M8 10h8M8 14.5h8M4.2 5.5h.1M4.2 10h.1M4.2 14.5h.1',
  numara: 'M8.5 5.5H16M8.5 10H16M8.5 14.5H16M3.5 4.5 4.5 4v3.5M3.3 11h1.6c.6 0 .6 1-.1 1.5l-1.5 1.5h2',
  baglanti: 'M8.5 11.5a3 3 0 0 0 4.2 0l2.6-2.6a3 3 0 0 0-4.2-4.2l-1 1M11.5 8.5a3 3 0 0 0-4.2 0l-2.6 2.6a3 3 0 0 0 4.2 4.2l1-1',
  temizle: 'M4 16h12M7 13 4.5 10.5 11 4l5 5-4 4H7Z',
  tut: 'M7.5 5h.1M7.5 10h.1M7.5 15h.1M12.5 5h.1M12.5 10h.1M12.5 15h.1',
  kutu: 'M3.5 6.5 10 3l6.5 3.5v7L10 17l-6.5-3.5v-7ZM3.5 6.5 10 10l6.5-3.5M10 10v7',
  onay: 'm4.5 10.5 3.5 3.5 7.5-8',
  uyari: 'M10 3.5 17.5 16h-15L10 3.5ZM10 8.5v3.5M10 14.2h.1',
  kalem: 'M4 16l.8-3.5L13.5 3.8l2.7 2.7-8.7 8.7L4 16Z',
};

export default function Ikon({ ad, boy = 18, kalin }: { ad: Ad; boy?: number; kalin?: boolean }) {
  return (
    <svg className="ccd-ui-ikon" width={boy} height={boy} viewBox="0 0 20 20" fill="none" stroke="currentColor"
         strokeWidth={kalin || ad === 'tut' ? 2.2 : 1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={YOL[ad]} />
    </svg>
  );
}
